import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHeadphones, 
  faWind, 
  faEye,
  faCheck
} from '@fortawesome/free-solid-svg-icons';
import ImageCarousel from '../components/ImageCarousel';
import './ServiziPage.css';

const ServiziPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll alla sezione ancorata se presente nell'URL
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);

  const carouselImages = [
    require("../assets/carousel/PHOTO-2025-10-16-20-09-02.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-03 2.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-03 3.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-03.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-04 2.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-04 3.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-05 2.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-05.jpg"),
    require("../assets/carousel/PHOTO-2025-10-16-20-09-06.jpg"),
  ];

  return (
    <div className="servizi-page">
      {/* Header Section */}
      <section className="servizi-header">
        <div className="servizi-header-container">
          <p className="servizi-header-label">I NOSTRI SERVIZI</p>
          <p className="servizi-header-description">
            Offriamo una gamma completa di servizi otorinolaringoiatrici, 
            utilizzando tecnologie moderne per garantire diagnosi precise e 
            trattamenti efficaci.
          </p>
        </div>
      </section>

      <section className="carousel-section">
        <ImageCarousel images={carouselImages} />
      </section>

      {/* Patologie Cards */}
      <section className="patologie-cards-section">
        <div className="patologie-cards-container">
          {/* Patologie dell'Orecchio */}
          <div id="orecchio" className="patologie-card">
            <div className="service-detail-icon">
              <FontAwesomeIcon icon={faHeadphones} />
            </div>
            <h2 className="service-detail-title">Patologie dell'Orecchio</h2>
            <p className="service-detail-intro">
              Diagnosi e trattamento di otiti, ipoacusia, acufeni, vertigini e 
              disturbi dell'equilibrio.
            </p>
            <ul className="service-list">
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Otiti acute e croniche</strong>
                  <p>Diagnosi e trattamento delle infezioni dell'orecchio medio ed esterno</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Ipoacusia e Sordità</strong>
                  <p>Valutazione dell'udito ed adattamento di protesi acustiche</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Acufeni</strong>
                  <p>Trattamento dei fischi e rumori nelle orecchie</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Vertigini e Disturbi dell'Equilibrio</strong>
                  <p>Diagnosi e terapia delle sindromi vertiginose</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Patologie del Naso */}
          <div id="naso" className="patologie-card">
            <div className="service-detail-icon">
              <FontAwesomeIcon icon={faWind} />
            </div>
            <h2 className="service-detail-title">Patologie del Naso</h2>
            <p className="service-detail-intro">
              Trattamento di sinusiti, riniti, deviazione del setto, polipi nasale e 
              disturbi respiratori.
            </p>
            <ul className="service-list">
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Sinusiti acute e croniche</strong>
                  <p>Trattamento delle infiammazioni dei seni paranasali</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Riniti allergiche e NON allergiche</strong>
                  <p>Gestione delle allergie e riniti croniche</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Deviazione del Setto Nasale</strong>
                  <p>Valutazione e correzione chirurgica quando necessaria</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Poliposi Nasale</strong>
                  <p>Diagnosi e trattamento dei polipi nasali</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Disturbi Respiratori</strong>
                  <p>Valutazione dell'ostruzione nasale e terapia</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Patologie della Gola */}
          <div id="gola" className="patologie-card">
            <div className="service-detail-icon">
              <FontAwesomeIcon icon={faEye} />
            </div>
            <h2 className="service-detail-title">Patologie della Gola</h2>
            <p className="service-detail-intro">
              Trattamento di faringiti, tonsilliti, disfonia, disturbi della 
              deglutizione e russamento.
            </p>
            <ul className="service-list">
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Faringiti e Tonsilliti</strong>
                  <p>Trattamento delle infezioni di faringe e tonsille</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Disfonia e Patologie della Voce</strong>
                  <p>Valutazione e trattamento dei disturbi vocali</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Disturbi della Deglutizione</strong>
                  <p>Diagnosi e trattamento della disfagia</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Russamento e Apnee Notturne</strong>
                  <p>Valutazione e soluzioni per migliorare il sonno</p>
                </div>
              </li>
              <li>
                <FontAwesomeIcon icon={faCheck} className="check-icon" />
                <div>
                  <strong>Laringiti croniche</strong>
                  <p>Trattamento delle infiammazioni della laringe</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="servizi-cta">
        <div className="servizi-cta-container">
          <h2 className="servizi-cta-title">Prenota la Tua Visita</h2>
          <p className="servizi-cta-description">
            Contattaci per fissare un appuntamento o per ricevere maggiori 
            informazioni sui nostri servizi.
          </p>
          <div className="servizi-cta-buttons">
            <a href="/contatti" className="btn-primary">Prenota Ora</a>
            <a href="tel:+393701627395" className="btn-secondary">Chiama</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiziPage;
